import {
  AUTH_START,
  AUTH_ERROR_RESET,
  AUTH_FAIL,
  AUTH_SUCCESS,
  AUTH_LOGOUT,
  AUTH_RESET_PASS_SUCCESS,
  AUTH_SOCIAL_MSG,
  AUTH_REFRESH_TOKEN,
  SET_LANGUAGE,
  SET_SAVE_FILES,
  SET_ONLINE_STATE,
} from '../actions/actionTypes'

const initialState = {
  attributes: null,
  user: null,
  userId: null,
  groups: [],
  isPro: false,
  isDoctor: false,
  isAuthenticated: false,
  token: null,
  error: null,
  loading: false,
  language: 'fr',
  saveFiles: false,
  socialMessage: '',
  isOnline: window.navigator.onLine,
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_START:
      return { ...state, loading: true, socialMessage: '', error: null }

    case AUTH_FAIL: {
      // Convert error message to i18n key code
      const errorMessage =
        typeof action.payload === 'string' || !action.payload
          ? action.payload
          : action.payload.message || action.payload.code

      const error =
        errorMessage && errorMessage.replace(/\s/g, '_').replace(/\W/g, '').toUpperCase()

      return {
        ...state,
        socialMessage: error ? '' : state.socialMessage,
        loading: false,
        error,
      }
    }

    case AUTH_SUCCESS:
      // TODO: Remove saveFiles once add it to attributes
      const { user, attributes, saveFiles } = action.payload

      const groups =
        user?.signInUserSession?.accessToken?.payload?.['cognito:groups'] || []

      const isDoctor = groups.includes('doctors')

      return {
        ...state,
        attributes,
        saveFiles,
        user,
        groups,
        isDoctor,
        userId: user.username,
        loading: false,
        isAuthenticated: !!user.signInUserSession,
        isPro: !!Number(attributes?.isPro),
        error: null,
        socialMessage: '',
      }

    case AUTH_LOGOUT:
      return {
        ...initialState,
        isOnline: window.navigator.onLine,
      }

    case SET_LANGUAGE:
      return { ...state, language: action.payload || 'fr' }

    case SET_SAVE_FILES:
      return { ...state, saveFiles: action.payload }

    case AUTH_ERROR_RESET:
      return { ...state, error: null }

    case AUTH_RESET_PASS_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        socialMessage: '',
      }

    case AUTH_SOCIAL_MSG: {
      return { ...state, socialMessage: action.payload }
    }

    case SET_ONLINE_STATE: {
      return { ...state, isOnline: action.payload }
    }

    case AUTH_REFRESH_TOKEN: {
      return { ...state }
    }

    default:
      return { ...state }
  }
}

export default authReducer
